export class SkuCodeRequest{
    skuCodeId : number;
    
    constructor(skuCodeId : number)
    {
        this.skuCodeId = skuCodeId;
        
    }
}
